module.exports = __webpack_public_path__ + "static/img/sedan-orange.afd2940.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/sedan-orange.svg
// module id = mVpd
// module chunks = 74